import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromUnits from 'app/state/units';
import { ICO2BottleVM } from 'app/models/co2-bottle';
import { Co2SvgComponent } from 'app/pages/home/co2/co2-svg.component';

/**
 * CO2 bottle row on location detail (same role as app-keg). Shows name, gauge
 * and weights, and links to CO2 detail. size/amount are already in display
 * units (getCO2BottlesWithUnit).
 */
@Component({
  selector: 'app-location-co2',
  templateUrl: './co2.component.html',
  styleUrls: ['./co2.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, RouterModule, Co2SvgComponent],
})
export class LocationCo2Component {
  @Input() co2: ICO2BottleVM | undefined;

  units = this.store.selectSignal(fromUnits.getUnits);

  constructor(private store: Store) {}
}
